module.exports = __webpack_public_path__ + "img/Rotation2.9e32903e.jpg";